const RapaNuiSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_112194)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#FCFCFC"
      />
      <path
        d="M26.0865 16.5215V18.2606H28.4734C27.4773 19.645 26.1505 20.7752 24.609 21.5362C24.2135 21.1253 23.6583 20.8693 23.043 20.8693C22.0059 20.8693 21.139 21.5958 20.9219 22.5676C20.618 22.5943 20.3104 22.6084 19.9996 22.6084C19.6887 22.6084 19.3812 22.5941 19.0772 22.5676C18.8601 21.5959 17.9933 20.8693 16.9562 20.8693C16.3409 20.8693 15.7858 21.1253 15.3902 21.5362C13.8487 20.7752 12.5219 19.6449 11.5258 18.2606H13.9126V16.5215H7.82568C7.82568 23.2448 13.2762 28.6954 19.9996 28.6954C26.7231 28.6954 32.1735 23.2448 32.1735 16.5215H26.0865Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_112194">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default RapaNuiSvg;
